import React from 'react'
import { components } from 'react-select'

import Highlighter from 'react-highlight-words'

const TwoPartOption = ({
  ...innerProps
}) => {
  const { data } = innerProps
  const { inputValue } = innerProps.selectProps

  const label = data.label || data.value
  const isArray = Array.isArray(label)

  const mainLabel = isArray
    ? label[0]
    : label

  const subLabel = isArray && label.length > 1
    ? label.slice(1).join(', ')
    : undefined

  return (
    <components.Option
      {...innerProps}
      className='vs-select-option'
    >
      {mainLabel && (
        <span className='vs-select-option__main'>
          <Highlighter
            highlightClassName='vs-select-option__highlight'
            searchWords={
              inputValue
                ? [inputValue]
                : []
            }
            textToHighlight={String(mainLabel)}
          />
        </span>
      )}

      {subLabel && (
        <span className='vs-select-option__sub'>
          <Highlighter
            highlightClassName='vs-select-option__highlight'
            searchWords={
              inputValue
                ? [inputValue]
                : []
            }
            textToHighlight={String(subLabel)}
          />
        </span>
      )}
    </components.Option>
  )
}

export default TwoPartOption
